import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import RandomBeer from './randomBeer/beer.js'
import './standardJS'
 function Beer() {
     return(
        <>
        <RandomBeer />
        </>
     )
 }

ReactDOM.render(
    <Beer />,
    document.getElementById("root")
);